import { Box } from '@wix/design-system';
import { TrustBuilders } from '@wix/package-picker-shared-studio';
import React from 'react';
import { FaqDivider } from '../FaqDivider';

interface TrustBuildersSectionProps {
  children?: React.ReactNode;
}

export const TrustBuildersSection = ({
  children,
}: TrustBuildersSectionProps) => (
  <>
    <Box width="100%" direction="vertical" gap="SP2" marginTop="72px">
      <TrustBuilders padding="0 40px" />
      {children}
    </Box>
    <FaqDivider />
  </>
);
